<template>
  <vue-form :name="'formPaymentMadeToInvoices'" :state="formstate" @submit.prevent="onSubmit" class="p-0 col-sm-12 col-md-12">
    <b-card>
      <h6 class="card-title">{{$t('views.exsbpaymentsmade.edit.paymentMadeToInvoice.header')}}</h6>
        <b-row>
          <b-col>
            <b-row>
              <Loader v-if="loadingInvoices"></Loader>
              <b-col v-if="dataArray.length > 0">
                <template v-for="(payment, index) in dataArray">
                  <OtherInvoices v-if="payment" v-bind:key="'payment-' + index" :removePayment="removePayment" :payment="payment"
                                  :index="index"></OtherInvoices>
                </template>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <div class="form-group">
                  <b-button class="btn btn-success mt-2" @click="addNewPayment()"><i class="fal fa-plus mr-2"></i>{{$t("views.exsbpaymentsmade.edit.split")}}</b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <div class="form-group">
                  <div class="float-left">
                    <input type="submit" :value="$t('buttons.send')" class="btn btn-success" />
                    <b-btn variant="info" @click="cancelButton()">
                      {{$t('buttons.cancel')}}
                    </b-btn>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
    </b-card>
  </vue-form>
</template>

<script>
import VueForm from 'vue-form'
import OtherInvoices from '@/components/Dashboard/Views/BusinessBundle/exsbpaymentsmade/components/OtherInvoices'
import ApiService from '@/utils/ApiService'
import Loader from '@/components/Dashboard/Layout/Loader'
export default {
  name: 'PaymentMadeToInvoice',
  mixins: [VueForm],
  components: {
    Loader,
    OtherInvoices
    // OtherInvoices
  },
  props: {
    paymentMade: {
      type: Object,
      required: false
    },
    fetchData: {
      type: Function,
      required: false
    },
    cancelButton: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      formstate: {},
      dataArray: [],
      data: {},
      loadingInvoices: true
    }
  },
  created () {
    this.getPaymentMadeDataFromProps()
  },
  methods: {
    async getPaymentMadeDataFromProps () {
      this.loadingInvoices = false
      this.data = Object.assign({}, this.paymentMade)
      if (!this.data.idEXSBInvoice) {
        this.data.idEXSBInvoice = null
      }
      for (let i in this.data.paymentsItems) {
        let object = {
          addAccountToAgreement: this.data.paymentsItems[i].addAccountToAgreement,
          value: this.data.paymentsItems[i].value,
          idAgreement: this.data.paymentsItems[i].idAgreement ? '/core/public/index.php/api/e_x_a_b_agreements/' + this.data.paymentsItems[i].idAgreement : null,
          idEXSBInvoice: this.data.paymentsItems[i].idEXSBInvoice ? '/core/public/index.php/api/e_x_s_b_invoices/' + this.data.paymentsItems[i].idEXSBInvoice : null,
          idPayment: this.data.paymentsItems[i].idPayment,
          idBankPayment: this.data.idBankPayment['@id'],
          autoAdd: 0
        }
        this.dataArray.push(object)
      }
    },
    addNewPayment (firstPayment = false) {
      let value = 0
      let idPaymentMade = null
      let idBankPayment = this.paymentMade.idBankPayment['@id']
      if (this.paymentMade) {
        idPaymentMade = this.paymentMade['@id']
      }
      if (this.paymentMade && firstPayment === true) {
        value = this.paymentMade.value
      }
      let object = {
        idPaymentMade: idPaymentMade,
        idBankPayment: idBankPayment,
        value: value,
        idEXSBInvoice: null,
        idAgreement: null,
        type: 1
      }
      this.dataArray.push(object)
    },
    removePayment (itemIndex) {
      this.removing = true
      this.dataArray.splice(itemIndex, 1)
    },
    onSubmit: function () { // send form
      if (this.formstate.$invalid) { // show error when form is not valid
        this.$Swal({
          type: 'error',
          title: this.$t('notifications.onSubmit.formTitle'),
          showConfirmButton: true,
          timer: 2500
        })
      } else {
        this.update()
      }
    },
    async update () {
      let id = this.paymentMade['@id']
      const response = await new ApiService(`${id}/pairwithinvoice`).put(this.dataArray)
      if (response.status === 200) {
        this.data = {
          addAccountToAgreement: 0
        }
        this.fetchData()
      }
    }
  }
}
</script>
